import React from 'react';
import { CarouselOverflow } from "@hm-group/fabric-components/components/CarouselOverflow";
import cn from 'classnames';
import { CAROUSEL_LABELS_FALLBACK, CAROUSEL_SLIDE_SPACING, MIN_PRODUCT_VARIANTS } from './constants';
import "./ProductVariants.css";
var styles = { "wrapper": "a4ae0f" };
import ProductImageLink from '../ProductImageContainer/components/ProductImageLink/ProductImageLink';
const ProductVariants = ({ layout, productVariants, className, labels }) => {
    if (layout !== 'big_carousel' ||
        !productVariants ||
        productVariants.length < MIN_PRODUCT_VARIANTS)
        return null;
    const shouldShrinkSlides = productVariants.length > MIN_PRODUCT_VARIANTS;
    const carouselLabels = {
        next: (labels === null || labels === void 0 ? void 0 : labels.carouselNextArrow) || CAROUSEL_LABELS_FALLBACK.NEXT,
        prev: (labels === null || labels === void 0 ? void 0 : labels.carouselPreviousArrow) || CAROUSEL_LABELS_FALLBACK.PREV,
    };
    const defaultSlidesPerBreakpoint = {
        default: shouldShrinkSlides ? 3 : 2,
        xsmall: shouldShrinkSlides ? 3 : 2,
        small: shouldShrinkSlides ? 3 : 2,
    };
    return (React.createElement("div", { className: cn(styles.wrapper, className) },
        React.createElement(CarouselOverflow, { slideSpacing: CAROUSEL_SLIDE_SPACING, labels: carouselLabels, slidesPerBreakpoint: defaultSlidesPerBreakpoint }, productVariants.map(({ pdpUrl, altText, imageSrc, shouldUseNextImage }) => (React.createElement(ProductImageLink, { key: pdpUrl, imageProductSrc: imageSrc, imageProductAlt: altText, pdpUrl: pdpUrl, shouldUseNextImage: shouldUseNextImage }))))));
};
export default ProductVariants;
//# sourceMappingURL=ProductVariants.js.map